import store from '@/store'

//起重的设备type
var qzArr = "1,2,3,5,6,8,9";
//起重的设备str
var qzStr = /^.*(qz)$/;
//计量的设备type
let jlArr = "4,7";
//计量的设备str
var jlStr = /^.*(jl)$/;

export default {
    inserted(dom, binding) {
        const equTypeId = store.getters.getEquTypeId ? store.getters.getEquTypeId : 1
        const devStr = getEquType(equTypeId)
        const inspectionRoles = store.state.user.inspectionRoles
        if(!devStr || inspectionRoles.length == 0) {
            dom.style.visibility = 'hidden'
        } else {
            const value = binding.value
            if (value && value instanceof Array && value.length != 0) {
                const inspPermis = inspectionRoles.some(inspectionRole => {
                    return value.includes(inspectionRole) && devStr.test(inspectionRole)
                })
                if (!inspPermis) {
                    dom.style.visibility = 'hidden'
                }
            } else {
                dom.style.visibility = 'hidden'
                throw new Error(`检验检测角色配置为空`)
            }
        }
    }
}

function getEquType(equType) {
    if(!equType) return null;
    var devStr;
    //判断起重设备的类型
    if(qzArr.includes(equType)){
        devStr = qzStr;
    }
    //判断计量设备
    if(jlArr.includes(equType)){
        devStr = jlStr;
    }
    return devStr
}
